import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'business-list.list-view.category-cell.edit-category-cell.placeholder',
		defaultMessage: 'Add category',
		description: 'Placeholder for category field',
	},
	createNewCategory: {
		id: 'business-list.list-view.category-cell.edit-category-cell.create-new-category',
		defaultMessage: 'New category',
		description: 'Text appearing next to the new category name being created',
	},
	noMatches: {
		id: 'business-list.list-view.category-cell.edit-category-cell.no-matches',
		defaultMessage: 'No matches found',
		description: 'Message to show when there are no categories found',
	},
});
